import React from "react";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import { Paper } from "@mui/material";
import cloud from "../../assets/db_images/cloud-data.png";
import legacy from "../../assets/db_images/legacy.png";
import cross from "../../assets/db_images/cross-platform.png";

const CloudMgmtService = () => {
  let featureList = [
    {
      id: uuidv4(),
      title: "Managed Cloud Service",
      image: cloud,
      description:
        "Are the partial or complete management and control of a client’s cloud platform, including migration, maintenance and optimization. By using a managed cloud service provider, a business can ensure its cloud resources run efficiently. Outsourcing cloud management also allows businesses to avoid new hiring and training costs Cloud managed services are the partial or complete management and control of an organization’s cloud platform, including cloud management, migration, maintenance and optimization",
    },
    {
      id: uuidv4(),
      title: "Cloud Computing",
      image: legacy,
      description:
        "Empower your business with our scalable cloud solutions, tailored for efficient data storage and seamless application hosting. Our expert migration services ensure a smooth transition to the cloud, minimizing disruptions. Experience ongoing excellence with our dedicated team managing and optimizing your cloud environments. Elevate your operations with Fint Infotech's comprehensive cloud services, designed for all types of customers. Embrace the future of technology with confidence and reliability.",
    },
    {
      id: uuidv4(),
      title: "Cybersecurity",
      image: cross,
      description:
        "Shield your digital assets with our robust security measures, fortifying defenses against evolving cyber threats. Our commitment extends to regular security assessments and proactive vulnerability management, ensuring a resilient security posture. Elevate your team's cybersecurity awareness through specialized employee training programs, fostering a culture of vigilance and preparedness. Trust Fint Infotech to be your steadfast partner in safeguarding your digital landscape. With our comprehensive approach, fortify your defenses, stay resilient, and navigate the digital realm with confidence.",
    },
  ];

  return (
    <div id="solutions">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Services we Provide
      </p>
      <div className="flex justify-evenly px-3 sm:px-20 mt-10 gap-3 flex-col sm:flex-row">
        {featureList.map((item) => (


          <div  key={item.id} class="w-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md">
            <div class="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              {item.title}
            </div>
            <div class="col-span-2 rounded-md">
             {item.description}
            </div>
            <div>
            <Button variant="outlined" href="#contact">Let's Connect</Button>
            </div>
          
          </div>
        ))}
      </div>
    </div>
  );
};

export default CloudMgmtService;
